export const CARD_SLIDE_HEIGHT = {
  small: 320,
  medium: 330,
  large: 340,
  xlarge: 360
};
